export default __webpack_public_path__ + "static/media/image.a78e572d.svg";